module.exports = __webpack_public_path__ + "static/img/living_taopin.f14ba2e0.png";